import { TimeEntry } from '../../../api/generated/data-contracts';
import { validationRules } from '../../validationRules';
import { ValidateResponse } from '../../Validator';
// import { NoMoreThenXHoursConfigValues } from './NoMoreThenXHoursConfig';

interface NoMoreThenXHoursProps {
    timeEntries: TimeEntry[];
    [key: string]: any;
}

export const NoMoreThenXHours = (props: NoMoreThenXHoursProps): ValidateResponse => {
    // console.log("🚀 ~ NoMoreThenXHours ~ props:", props)
    const maxHours = props.timeSheetValidation.maxHoursAllowedPerPeriod || 38;

    const sum = props.timeEntries.reduce((total, val) => (total += val.hours), 0);

    const valid = sum <= maxHours;

    const response: ValidateResponse = {
        reason: sum > maxHours ? `It is not allowed to report more than ${maxHours} hours per period` : null,
        valid: valid,
        name: validationRules.maxHoursAllowedPerPeriod,
        rejected: !valid,
    };

    return response;
};
